import React from "react";

export function AgentAvatar({ name, src, size = 28, className = "" }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  const style = { width: size, height: size };
  if (src) {
    return (
      <img
        src={src}
        alt={name || "Agent"}
        style={style}
        className={`rounded-full border border-violet-300/30 object-cover ${className}`}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    );
  }
  const fontSize = Math.max(10, Math.round(size * 0.4));
  return (
    <span
      style={{ ...style, fontSize }}
      className={`inline-flex items-center justify-center rounded-full border border-violet-300/30 bg-gradient-to-br from-violet-500/40 to-pink-500/30 font-semibold uppercase text-violet-100 ${className}`}
    >
      {initial}
    </span>
  );
}

export default AgentAvatar;
